export default "__VITE_ASSET__dd00ca7c__"